// extracted by mini-css-extract-plugin
export default {"container":"KHBkrw8zGQ2XJhLKA0Sg","organisationInfo":"r0KdXPWcH0lqRsVnC3fQ","shortDescription":"uexGXV89irJDO9ndxXRZ"};